import React, { useEffect, useState } from 'react';
import axios from "axios";
import { BASE_URL } from "../../config";
import { useNavigate } from 'react-router-dom';
import tickCrcleArrow from "../../assets/images/tick-circle-icon.svg";
import authStorage from "../../utils/authStorage";

const PaymentAppConfirm = ({back}) => {
    const [paymentDetail, setPaymentDetail] = useState('');
    const [deviceStatus, setDeviceStatus] = useState(false);
    const[checkSub,setCheckSub]=useState();
    const navigate = useNavigate();
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    const [email, setEmail] = useState(authStorage.getItem('email'));
    const [loading, setLoading] = useState(false);

    const getDeviceStatus = () => {
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token"),
            },
            url: `${BASE_URL}/user/device/status`, //your url
            method: "GET",
        }).then((res) => {
            setDeviceStatus(res.data.isFitbitConnected || res?.data?.isGarminConnected);
        });
    };

    const checkUserSubscription = () => {
       let subId=authStorage.getItem("subId");
        console.log("subID",subId);
        
        setLoading(true);
        axios({
            url: `${BASE_URL}/auth/check-subscription/${subId}`,
            method: "get",
            headers: {
                "x-access-token": authStorage.getItem("auth-token")
            }
        }).then((data) => {
            setPaymentDetail(data?.data);
            authStorage.setItem("subscribedStatus",true);
            authStorage.removeItem("subId");
            setLoading(false);

            // Redirect after 2 seconds
            setTimeout(() => {
                window.location.href = "cftapp://auth-callback?token=" + authStorage.getItem("auth-token");
            }, 2000);
        });
    };

    useEffect(() => {
        getDeviceStatus();
        checkUserSubscription();
    }, []);

    const updateWalkthrough = (e) => {
        axios({
            headers: {
                "x-access-token": authStorage.getItem("auth-token"),
            },
            url: `${BASE_URL}/user/update/walkthrough`, //your url
            method: 'PUT',
            data: { walkThroughPending: true, walkThroughSteps: 1 }
        }).then((res) => {
            authStorage.setItem('walkthrough', JSON.stringify({ walkThroughPending: true, walkThroughSteps: 1 }))
        }).catch((err) => {
        });
    };

    const walkThroughPending = JSON.parse(authStorage.getItem('walkthrough'))?.walkThroughPending;

    return (
        <div className="payment-completed">
            <div className="">
                <div className="icon-box">
                <img src={tickCrcleArrow} />
                </div>
                <h1>Payment Completed!</h1>
                <a
                    href="#"
                    className="continue-btn"
                    onClick={() => {
                        window.location.href =
                        "cftapp://auth-callback?token=" + authStorage.getItem("auth-token");
                    }}
                >
                Continue
                </a>
            </div>
        </div>
    )
}
export default PaymentAppConfirm;